import { ToastService } from './../../../../../../core/toast.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SendForApprovalMultipleSecondHandSuppliesService } from '../../services/send-for-approval-multiple-second-hand-supplies.service';

@Component({
  selector: 'app-send-for-approval-multiple',
  templateUrl: './send-for-approval-multiple.component.html',
  styleUrls: ['./send-for-approval-multiple.component.scss']
})
export class SendForApprovalMultipleComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */

/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private dialogRef: MatDialogRef<SendForApprovalMultipleComponent>,
    @Inject(MAT_DIALOG_DATA) public idArray: string[],
    private sendForApprovalMultipleSecondHandSuppliesService: SendForApprovalMultipleSecondHandSuppliesService,
    private toast: ToastService
  ) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }

/* ------------------------------ Close Dialog ------------------------------ */

  closeDialog(status: string) {
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }

async  sendForApproval(){
  try{
    await this.sendForApprovalMultipleSecondHandSuppliesService.updateMultipleSecondHandSupplies(this.idArray);
    this.closeDialog('yes');
    this.toast.openSnackBar("pre owned supplies are sent for approval");
  }catch(error){
    this.toast.openSnackBar("Unable to send pre owned supplies for approval");
  }
  }
}





